import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axiosInstance from "../../../axiosInterceptor";
import { useLocation, useNavigate } from "react-router-dom";
import ProductImageUploader from "./components/ProductImageUploader";
import TagsInput from "react-tagsinput";
import { Sizemultiselect } from "../../../Components/Labels";
import { AttributeInput } from "../../../Components/AttributeInputType";
import { CatalogueproductValidationSchema } from "../../../Schema/Schema";
import {
   AttributeStructuredata,
} from "../../../helper/ProductAttributeHandling";


const AddCatalogueProduct = () => {
   const location = useLocation();
   const navigate = useNavigate();
   const catalogue_basic_detail = location.state;
   const noOfProducts = catalogue_basic_detail?.noOfProducts || 1;
   const [formStates, setFormStates] = useState([]);
   const [formErrors, setFormErrors] = useState([]);
   const [sizedata, setsizedata] = useState([]);
   const [selectedValuesList, setSelectedValuesList] = useState([]);
   const [submittingStates, setSubmittingStates] = useState([]);
   const [attributes,setAttributes]=useState([])
   const fetchMeta = async () => {
     
      try {
         const [sizeRes,attributes] = await Promise.all([
            axiosInstance.get("/size"),
            axiosInstance.get("/attribute-children")
         ]);
         setsizedata(sizeRes.data.data || []);
         setAttributes(attributes.data.data || [])
      } catch (error) {
         toast.error("Error fetching metadata");
      }
   };

   useEffect(() => {
      if (formStates.length > 0) {
         setSubmittingStates(Array(formStates.length).fill(false));
      }
   }, [formStates]);


   const initializeForms = async () => {
      if (catalogue_basic_detail?.id) {
         const response = await axiosInstance.get(
            `catalogue/products/${catalogue_basic_detail?.id}`
         );
         const products = response.data?.data?.Product || [];
         const totalForms = catalogue_basic_detail?.noOfproduct || products.length;
         const filledForms = Array.from({ length: totalForms }, (_, index) => {
            const product = products[index];
            const combinedImages = (product?.image || []).map((original, index) => ({
               original,
               thumbImage: product?.thumbImage?.[index] || "",
               mediumImage: product?.mediumImage?.[index] || "",
            }));
            return {
               id: product?.id || undefined,
               name: product?.name || "",
               sku: product?.sku || "",
               quantity: product?.quantity || 0,
               weight: product?.weight || 0,
               stitching: catalogue_basic_detail?.optionType === "stitching",
               retail_price: product?.retail_price || 0,
               average_price:
                  catalogue_basic_detail?.average_price || product?.average_price || 0,
               retail_discount: product?.retail_discount || 0,
               offer_price: product?.offer_price || 0,
               description: product?.description || "",
               collection_id: catalogue_basic_detail?.collection_id || [],
               homeSectionId: catalogue_basic_detail?.homeSectionId || [],
               tag: product?.tag || [],
               catalogue_id: catalogue_basic_detail?.id,
               video:product?.video,
               relatedProduct: product?.relatedProducts || [],
               sizes: catalogue_basic_detail?.selctedsize || product?.sizes || catalogue_basic_detail?.selctedsize || [],
               showInSingle: catalogue_basic_detail?.selection,
               postId: product?.postId || null,
               category_id:
                  catalogue_basic_detail?.categoriesId ||
                  product?.categories?.map((cat) => cat.category_id),
               attributes: product?.attributes || [],
               images: combinedImages,
               meta_title: product?.meta_title || "",
               meta_keyword: product?.meta_keyword || "",
               meta_description: product?.meta_description || "",
               optionType: catalogue_basic_detail?.optionType ||  product?.optionType ,
               brandIds: product?.ProductBrand?.map((b) => b.brand_id) || [],
            };
         });

         const transformedData = filledForms.map((f) =>
            AttributeStructuredata(f.attributes || [])
         );
         setSelectedValuesList(transformedData);

         setFormStates(filledForms);
         setFormErrors(Array(totalForms).fill({}));
         setSubmittingStates(Array(totalForms).fill(false));
      }
   };
   useEffect(() => {
      fetchMeta();
      initializeForms();
   }, [catalogue_basic_detail]);
   const handleFormChange = async (index, field, value) => {
      const updatedForms = [...formStates];
      updatedForms[index][field] = value;
      if (field === "retail_price" || field === "retail_discount") {
         const retail_price = parseFloat(updatedForms[index].retail_price) || 0;
         const retail_discount = parseFloat(updatedForms[index].retail_discount) || 0;
         updatedForms[index].offer_price =
            retail_discount > 0
               ? (retail_price - (retail_price * retail_discount) / 100).toFixed(2)
               : retail_price.toFixed(2);
      }

      setFormStates(updatedForms);
      try {
         await CatalogueproductValidationSchema.validateAt(field, updatedForms[index]);
         setFormErrors((prev) => {
            const updated = [...prev];
            if (updated[index]) {
               delete updated[index][field]; 
            }
            return updated;
         });
      } catch (err) {
         setFormErrors((prev) => {
            const updated = [...prev];
            if (!updated[index]) updated[index] = {};
            updated[index][field] = err.message;
            return updated;
         });
      }
   };

   const handleAttributesChange = (index, key, value) => {
      const updatedAttrs = [...selectedValuesList];
      updatedAttrs[index] = {
         ...updatedAttrs[index],
         [key]: value,
      };
      setSelectedValuesList(updatedAttrs);
   };
   const handleApplyToAll = (fromIndex) => {
      const baseForm = formStates[fromIndex];
      const baseAttributes = selectedValuesList[fromIndex];
    const newForms = formStates.map((form) => ({
    ...baseForm,
    images: JSON.parse(JSON.stringify(form.images)), // images NOT copied
    video: form.video, // video bhi individual rahe
  }));
      // const newAttrs = selectedValuesList.map(() => ({ ...baseAttributes }));
       const newAttrs = selectedValuesList.map(() =>
    JSON.parse(JSON.stringify(baseAttributes))
  );
      setFormStates(newForms);
      setSelectedValuesList(newAttrs);
      toast.info("Values copied to all products (images excluded).");
   };

   const handleSingleSubmit = async (index) => {
      const payload = {
         ...formStates[index],
         attributes: selectedValuesList[index],
          collection_id: catalogue_basic_detail?.collection_id || [],
  homeSectionId: catalogue_basic_detail?.homeSectionId || [],
      };

      try {
         await CatalogueproductValidationSchema.validate(payload, {
            abortEarly: false,
         });
      } catch (error) {
         const productErrors = {};
         if (error.inner) {
            error.inner.forEach((e) => {
               productErrors[e.path] = e.message;
            });
         }

         setFormErrors((prev) => {
            const updated = [...prev];
            updated[index] = productErrors;
            return updated;
         });

         return;
      }

      setFormErrors((prev) => {
         const updated = [...prev];
         updated[index] = {};
         return updated;
      });


      setSubmittingStates((prev) => {
         const updated = [...prev];
         updated[index] = true;
         return updated;
      });

      try {
         if (payload.id) {
            await axiosInstance.put(`catalogue-product/${payload.id}`, payload);
         } else {
            await axiosInstance.post("catalogue-product", payload);
         }
         toast.success(`Product ${index + 1} submitted successfully!`);
    const isLast = index === formStates.length - 1;
    if (isLast) {
      setTimeout(() => navigate(`/catalogue/${catalogue_basic_detail?.category_id}`), 1000); 
    }
      } catch (apiError) {
         toast.error(`Product Error ${index + 1} ${apiError.response?.data?.message}`);
      } finally {
         setSubmittingStates((prev) => {
            const updated = [...prev];
            updated[index] = false;
            return updated;
         });
      }
   };
   const getError = (index, field) => formErrors[index]?.[field];
   return (
      <div className="content-wrapper mt-5">
         <h3 className="page-title mb-5">Add Catalogue Products ({noOfProducts})</h3>
         {formStates.map((form, index) => (
            <div key={index} className="rounded bg-white p-4 mb-4 shadow">
               <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5>Product {index + 1}</h5>
                  {
                     !form.id && (
                        <button
                           type="button"
                           className="btn btn-sm btn-warning"
                           onClick={() => handleApplyToAll(index)}
                        >
                           Apply To All
                        </button>

                     )
                  }
               </div>

               <div className="row">
                  <div className="col-md-4 mb-4">
                     <label>Name</label>
                     <input
                        className="form-control border border-dark"
                        type="text"
                        value={form.name}
                        placeholder="Enter name"
                        onChange={(e) => handleFormChange(index, "name", e.target.value)}
                     />
                     {getError(index, "name") && (
                        <small className="text-danger">{getError(index, "name")}</small>
                     )}
                  </div>

                  <div className="col-md-4">
                     <label>SKU</label>
                     <input
                        className="form-control border border-dark"
                        type="text"
                        value={form.sku}
                        placeholder="Enter sku"
                        onChange={(e) => handleFormChange(index, "sku", e.target.value)}
                     />
                     {getError(index, "sku") && (
                        <small className="text-danger">{getError(index, "sku")}</small>
                     )}
                  </div>

                  <div className="col-md-4">
                     <label>Quantity</label>
                     <input
                        className="form-control border border-dark"
                        type="number"
                        value={form.quantity}
                        placeholder="Enter quantity"
                        onChange={(e) => handleFormChange(index, "quantity", e.target.value)}
                     />
                     {getError(index, "quantity") && (
                        <small className="text-danger">{getError(index, "quantity")}</small>
                     )}
                  </div>

                  <div className="col-md-4 mb-4">
                     <label>Weight</label>
                     <input
                        className="form-control border border-dark"
                        type="number"
                        value={form.weight}
                        placeholder="Enter weight"
                        onChange={(e) => handleFormChange(index, "weight", e.target.value)}
                     />
                     {getError(index, "Weight") && (
                        <small className="text-danger">{getError(index, "Weight")}</small>
                     )}
                  </div>

               
                 
                        <div className="col-md-4">
                           <label>Price </label>
                           <input
                              className="form-control border border-dark"
                              type="number"
                              value={form.retail_price}
                              placeholder="Enter price"
                              onChange={(e) =>
                                 handleFormChange(index, "retail_price", e.target.value)
                              }
                           />
                        </div>

                        <div className="col-md-4">
                           <label>Discount</label>
                           <input
                              className="form-control border border-dark"
                              type="number"
                              value={form.retail_discount}
                              placeholder="Enter  discount"
                              onChange={(e) =>
                                 handleFormChange(index, "retail_discount", e.target.value)
                              }
                           />
                        </div>

                        <div className="col-md-4">
                           <label>Offer Price </label>
                           <input
                              className="form-control border border-dark"
                              type="number"
                              value={form.offer_price}
                              placeholder="Enter offer price"
                              readOnly
                           />
                        </div>
                 
               

                  {attributes && attributes?.length > 0 && attributes?.map((attribute) => (
                     <div className="col-md-4 mb-4" key={attribute.id}>
                        <label>{attribute.name}</label>
                        <AttributeInput
                           attribute={attribute}
                           selectedValues={selectedValuesList[index] || {}}
                           onSave={(key, val) => handleAttributesChange(index, key, val)}
                           handleInputChange={(key, val) =>
                              handleAttributesChange(index, key, val)
                           }
                        />
                     </div>
                  ))}

                  <div className="col-md-4">
                     <label>Related Products</label>
                     <TagsInput
                        value={form.relatedProduct}
                        onChange={(value) => handleFormChange(index, "relatedProduct", value)}
                         inputProps={{
    placeholder: "Products SKU",
  }}
                     />
                  </div>

                  <div className="col-md-4">
                     <label>Tags</label>
                      <TagsInput
                        value={form.tag}
                        onChange={(tag) => handleFormChange(index, "tag", tag)}
                         inputProps={{
    placeholder: "Related Tags",
  }}
                     />
                  </div>


 <div className="col-md-4">
                     <label>Instagram Post Id</label>
                     <input
                        type="text"
                        className="form-control border border-dark"
                        value={form.postId}
                       placeholder="Enter Post Id"
                        onChange={(e) => handleFormChange(index, "postId", e.target.value)}
                     />
                  </div>

                    <div className="col-md-4">
                     <label>Meta Title</label>
                     <input
                        type="text"
                        className="form-control border border-dark"
                        value={form.meta_title}
                        placeholder="Enter meta title"
                        onChange={(e) => handleFormChange(index, "meta_title", e.target.value)}
                     />
                  </div>


                   <div className="col-md-6 mb-4">
                     <label>Meta Keyword</label>
                     <textarea
                        type="text"
                        className="form-control border border-dark"
                        value={form.meta_keyword}
                         placeholder="Enter meta keywords"
                        onChange={(e) =>
                           handleFormChange(index, "meta_keyword", e.target.value)
                        }
                     />
                  </div>

                  <div className="col-md-6">
                     <label>Meta Description</label>
                     <textarea
                        className="form-control border border-dark" 
                        value={form.meta_description}
                         placeholder="Enter meta description"
                        onChange={(e) =>
                           handleFormChange(index, "meta_description", e.target.value)
                        }
                     />
                  </div>

                  <div className="col-md-12">
                     <label>Description</label>
                     <textarea
                        className="form-control border border-dark"
                        value={form.description}
                         placeholder="Enter description"
                        rows={5}
                        onChange={(e) => handleFormChange(index, "description", e.target.value)}
                     />
                  </div>

                  <div className="col-md-12 mt-4">
                     <label>Images</label>
                      <small className="form-text ">
                            Required image size: 750px × 1125px (.png, .jpg, .jpeg, .webp)
                          </small>
                        <ProductImageUploader
                        key={`uploader-${index}`}
  uploaderId={`product-${index}`}   
                           initialImages={form.images}
                           onUploadComplete={(urls) => handleFormChange(index, "images", urls)}
                        />
                     {getError(index, "images") && (
                        <small className="text-danger">{getError(index, "images")}</small>
                     )}
                  </div>

                   {/* <div className="col-md-12 mt-4">
                                             <div className="form-group">
                                              <label className="col-form-label ">Video (Optional)</label>
                                            <small className="form-text ">
                                              Maximum Sizes 7MB
                                            </small>
                                                      <Upload
                                                        label="image-video"
                                                        initialImage={form.video}
                                                         onChange={(urls) => handleFormChange(index, "video", urls)}
                                                        apiUrl={"uploads?label=product"}
                                        
                                                      />
                                             </div>
                                                    
                                                    </div> */}
                  {catalogue_basic_detail?.optionType === "Size" && sizedata.length > 0 && (
                     <div className="col-md-6 mt-4">
                        <Sizemultiselect
                           sizedata={sizedata}
                           values={form.sizes}
                           totalQuantity={form.quantity || 0}
                           setFieldValue={(name, value) => handleFormChange(index, name, value)}
                           type="catalogue"
                        />
                     </div>
                  )}



                  <div className="col-12 text-center mt-5">
                     <button className="btn btn-danger mr-2" onClick={()=>navigate(`/catalogue/${catalogue_basic_detail?.category_id}`)}>Cancel</button>
                     <button
                        className="btn btn-primary"
                        onClick={() => handleSingleSubmit(index)}
                        disabled={!!submittingStates[index]}
                     >
                        {submittingStates[index] ? (
                           <>
                              <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                              &nbsp;Submitting...
                           </>
                        ) : (
                           `Submit Product ${index + 1}`
                        )}
                     </button>
                  </div>

               </div>
            </div>
         ))}
      </div>
   );
};

export default AddCatalogueProduct;
